import PawsLayout from "@/layouts/paws/index";
import NavigationElement from "@/components/navigation-element/index";

import NAVIGATION from "@/data/puppy-weekend/navigation.yaml";

export default {
  components: { PawsLayout, NavigationElement },
  data() {
    return {
      navigationElements: NAVIGATION,
    };
  },
};
